import {
  Box,
  Columns,
  Container,
  Heading,
  Stack,
  Text,
} from '@spaceship-fspl/components';
import { height, width } from '@spaceship-fspl/styles';
import { PanelSection } from 'components';
import * as React from 'react';
import styled, { css } from 'styled-components';

export interface ValuesPanelProps {
  title: string;
  values: Array<{
    title: string;
    tagline: string;
    summary: string;
    iconURL: string;
  }>;
}

const ValueIcon = styled.img<{ title: string }>`
  ${height('auto')}
  align-self: flex-start;
  max-width: 100%;

  ${({ title }) => {
    switch (title) {
      case 'Forward-thinking': {
        return css`
          ${width({ xs: 160, md: 217, lg: 260 })}
        `;
      }
      case 'Accessible': {
        return css`
          ${width({ xs: 160, md: 263, lg: 314 })}
        `;
      }
      case 'Curious': {
        return css`
          ${width({ xs: 243, md: 313, lg: 375 })}
        `;
      }
      case 'Transparent': {
        return css`
          ${width({ xs: 160, md: 226, lg: 270 })}
        `;
      }
      case 'Straightforward': {
        return css`
          ${width({ xs: 160, md: 244, lg: 292 })}
        `;
      }
      default:
        return '';
    }
  }};
`;

export const ValuesPanel: React.FC<
  React.PropsWithChildren<ValuesPanelProps>
> = ({ title, values }) => (
  <PanelSection>
    <Container>
      <Columns alignX="center">
        <Columns.Column width={{ xs: 1, lg: 10 / 12 }}>
          <Stack spaceY={{ xs: 'lg', lg: 'xxl' }}>
            <Heading variant={2} align="center">
              {title}
            </Heading>

            <Stack spaceY={{ xs: 'lg', md: 'xl', lg: 'xxl' }}>
              {values.map(({ title, tagline, summary, iconURL }, index) => (
                <Columns
                  key={`${title}-${index}`}
                  spaceX={{ xs: 'none', md: 'xl', lg: 'xxl' }}
                  spaceY={{ xs: 'sm', md: 'none' }}
                  alignY="center"
                >
                  <Columns.Column width={{ xs: 1, md: 1 / 2 }}>
                    <Box display="flex" justifyContent="center" flexShrink={1}>
                      <ValueIcon title={title} src={iconURL} alt="" />
                    </Box>
                  </Columns.Column>
                  <Columns.Column width={{ xs: 1, md: 1 / 2 }}>
                    <Stack spaceY="sm">
                      <Stack spaceY="xxxs">
                        <Heading
                          component="h3"
                          variant={3}
                          align={{ xs: 'center', md: 'left' }}
                        >
                          {title}
                        </Heading>
                        <Text variant={1} align={{ xs: 'center', md: 'left' }}>
                          {tagline}
                        </Text>
                      </Stack>
                      <Text
                        variant={1}
                        align={{ xs: 'center', md: 'left' }}
                        color="neutral.080"
                      >
                        {summary}
                      </Text>
                    </Stack>
                  </Columns.Column>
                </Columns>
              ))}
            </Stack>
          </Stack>
        </Columns.Column>
      </Columns>
    </Container>
  </PanelSection>
);
